import React, { useState } from 'react';
import { TongueDiagnosis } from './components/TongueDiagnosis';
import { PulseDiagnosis } from './components/PulseDiagnosis';
import { TongueReference } from './components/TongueReference';
type TabType = 'tongue' | 'pulse' | 'reference';
export interface DiagnosisData {
  tongue: {
    images: {
      frontal: string | null;
      sublingual: string | null;
    };
    colors: string[];
    shapes: string[];
    coating: string[];
    moisture: string[];
    sublingualVeins: string[];
  };
  pulse: Record<string, string>;
}
export function App() {
  const [activeTab, setActiveTab] = useState<TabType>('tongue');
  const [diagnosisData, setDiagnosisData] = useState<DiagnosisData>({
    tongue: {
      images: {
        frontal: null,
        sublingual: null
      },
      colors: [],
      shapes: [],
      coating: [],
      moisture: [],
      sublingualVeins: []
    },
    pulse: {}
  });
  const tabs = [{
    id: 'tongue' as TabType,
    label: '👅 Tongue Diagnosis'
  }, {
    id: 'pulse' as TabType,
    label: '💓 Pulse Diagnosis'
  }, {
    id: 'reference' as TabType,
    label: '📚 Reference Table'
  }];
  return <div className="w-full min-h-screen bg-gradient-to-br from-green-50 to-blue-50" data-id="element-0">
      <div className="max-w-7xl mx-auto p-6" data-id="element-1">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-2">
          <h1 className="text-4xl font-bold text-gray-800 mb-2" data-id="element-3">
            🌿 TCM Diagnosis System
          </h1>
          <p className="text-gray-600" data-id="element-4">
            Traditional Chinese Medicine Pattern Identification & Analysis
          </p>
        </div>
        {/* Tabs */}
        <div className="flex flex-wrap gap-2 mb-6 bg-white rounded-lg p-2 shadow-md" data-id="element-5">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 rounded-md font-medium transition-all ${activeTab === tab.id ? 'bg-green-600 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-6">
              {tab.label}
            </button>)}
        </div>
        {/* Tab Content */}
        <div className="bg-white rounded-lg shadow-lg p-6" data-id="element-7">
          {activeTab === 'tongue' && <TongueDiagnosis data={diagnosisData.tongue} onChange={tongue => setDiagnosisData({
          ...diagnosisData,
          tongue
        })} data-id="element-8" />}
          {activeTab === 'pulse' && <PulseDiagnosis data={diagnosisData.pulse} onChange={pulse => setDiagnosisData({
          ...diagnosisData,
          pulse
        })} data-id="element-9" />}
          {activeTab === 'reference' && <TongueReference data-id="element-10" />}
        </div>
      </div>
    </div>;
}